/** @flow */
import axios from 'axios';
import moment from 'moment';
import { cdn } from 'common/config/config';
import api from 'common/services/api';
import Antenna from 'statsradio/domain/Antenna';
import GeoMapLayout from '../modules/dashboard/domain/GeoMapLayout';

const ISO_DATE = 'YYYY-MM-DD';

class GeolocalisationApi {

  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async getReachByRegions(callSign: string, token: string, country: string, state: string, from: moment, to: moment) {
    try {
      const { data } = await api.get(`/reach/${callSign}/geolocalisation/regions`, {
        country: country,
        state: state,
        from: from.format(ISO_DATE),
        to: to.format(ISO_DATE),
      }, {
        headers: this.buildHeaders(token),
      });
      return data;
    } catch (e) {
      throw new Error('Something wrong happened when retrieving geolocalisation.');
    }
  }

  async fetchVisualMap(): Promise<GeoMapLayout> {
    const geoMap = 'visual-map';

    return axios
      .get(`${cdn.maps}/${geoMap}.json`)
      .then(response => GeoMapLayout.parse(response.data));
  }

  async getAntennasData(callSign: string, token: string): Promise<Antenna[]> {
    const { data } = await api.get(`/statsradio/radios/${callSign}/antennas`, {}, { headers: this.buildHeaders(token) });
    return data.map(i => Antenna.parse(i));
  }
}

export default new GeolocalisationApi();



// WEBPACK FOOTER //
// ./src/statsradio/services/geolocalisationApi.js